<template>
  <div class="form-group mt-5" :class="{ hasValue: showInput }">
    <div :class="{ invalid: isInvalid() }">
      <input
        ref="item"
        :type="config.InputType"
        :name="'text' + id"
        :data-vv-as="config.ErrorMessage"
        v-validate="config.Validation"
        :id="'input' + id"
        class="form-control"
        :value="value"
        :required="config.Validation.required"
        @input="update()"
        @change="doChange()"
        @blur="update()"
      />
    </div>
    <label class="form-control-placeholder" :for="'input' + id">
      <span>{{ config.Placeholder }}</span>
      <span
        class="required-star"
        v-if="config.Validation.required && config.Placeholder"
        >*</span
      >
    </label>
    <InfoText v-if="config.Info" :content="config.Info" :id="id" />
    <div class="invalid-mandatory" ref="error" v-if="isInvalid()">
      {{ this.config.ErrorMessage }}
    </div>
  </div>
</template>

<script>
  import InfoText from '@/components/base/InfoText';

  export default {
    components: { InfoText },
    inject: {
      $validator: '$validator',
    },
    props: ['value', 'id', 'config'],
    data() {
      return {
        showInput: false,
      };
    },
    methods: {
      update() {
        // check if valid

        if (this.value || this.$refs.item.value) {
          this.showInput = true;
        } else {
          this.showInput = false;
        }
        let tempVal = this.$refs.item.value.replace(/[ \D]/gi, '');
        let output = tempVal;
        if (output.length > 6) {
          output = [tempVal.slice(0, 6), '-', tempVal.slice(6)].join('');
        }
        this.$emit('input', output);
      },
      doChange() {
        this.$emit('getNewData');
      },
      isInvalid() {
        return (
          this.$store.state.componentIsInvalid &&
          (!this.value ||
            (this.errors.first('text' + this.id) &&
              this.config.Validation.required))
        );
      },
    },
    created() {
      this.$validator.extend('cpr', {
        validate(value) {
          let main_int = 0;
          let factors = [4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
          value = value.replace(/[ \D]/gi, '');
          if (
            typeof value === 'undefined' ||
            value === '' ||
            (value.length !== 10 && value.length !== 11)
          ) {
            return false;
          }

          for (var ciffer = 0; ciffer < value.length; ciffer++) {
            main_int += parseInt(value.substr(ciffer, 1)) * factors[ciffer];
          }
          return main_int % 11 == 0;
        },
      });
      setTimeout(() => {
        if (this.value) {
          this.showInput = true;
        } else {
          this.showInput = false;
        }
      }, 100);
    },
  };
</script>
